/** Placeholder — Stuart will set the real Excellent cutoff. */
export const EXCELLENT_THRESHOLD = 85;
/** Placeholder — Stuart will set the real Good cutoff. */
export const GOOD_THRESHOLD = 70;
/** Matches the Ari worker MIN_MATCH relevance floor. */
export const SUPPRESSION_THRESHOLD = 20;

/**
 * @param {number|string} score
 * @returns {'excellent'|'good'|'average'|null} null = suppress (do not render)
 */
export function getMatchBand(score) {
  const value = Number.parseFloat(score);
  if (!Number.isFinite(value) || value < SUPPRESSION_THRESHOLD) {
    return null;
  }
  if (value >= EXCELLENT_THRESHOLD) {
    return 'excellent';
  }
  if (value >= GOOD_THRESHOLD) {
    return 'good';
  }
  return 'average';
}

export const MATCH_BAND_LABELS = {
  excellent: 'Excellent match',
  good: 'Good match',
  average: 'Average match',
};

/**
 * Keep at most two sentences from Ari's reason text.
 *
 * @param {string} reason
 * @returns {string}
 */
export function truncateReasonToTwoSentences(reason = '') {
  const trimmed = String(reason || '').trim();
  if (!trimmed) {
    return '';
  }

  const parts = trimmed.match(/[^.!?]+[.!?]+|[^.!?]+$/g);
  if (!parts || parts.length <= 2) {
    return trimmed;
  }

  return parts
    .slice(0, 2)
    .map((part) => part.trim())
    .join(' ');
}
